import React from 'react'
import { Outlet } from 'react-router-dom'

export const ToolkitApp: React.FC = () => {
  return (
    <main
      className="min-h-screen bg-[#EDE6DE] px-4 py-12 md:px-8 lg:px-16"
      data-testid="toolkit-app-container"
    >
      <Outlet />
    </main>
  )
}
